const constants = {
  set: 'BOARD_SUMMARY_SET',
};

const set = (boardSummary) => ({
  type: constants.set,
  payload: boardSummary,
});

const boardSummaryActions = {
  constants,
  set,
};

export default boardSummaryActions;
